<template>
	<div class="position-relatives">
		<v-progress-linear
			absolute
			v-if="loadingFetchEmployee"
			indeterminate
			color="primary darken-4"></v-progress-linear>
		<div class="d-flex justify-space-between align-center">
			<v-tabs
				v-model="tabs"
				height="65"
				active-class="mid-primary"
				color="white">
				<v-tab
					:to="{
						name: 'personal-info',
						query: { employeeId: $route.query.employeeId, name: $route.query.name },
					}">
					<v-icon class="me-1"> mdi-badge-account-horizontal-outline </v-icon>
					{{ $T('tabs.info') }}
				</v-tab>
				<template v-if="isEmployee">
					<v-tab
						:to="{
							name: 'employee-attendance',
							query: { employeeId: $route.query.employeeId, name: $route.query.name },
						}">
						<v-icon class="me-1"> mdi-calendar-edit-outline </v-icon>
						{{ $T('tabs.work-and-Vacations') }}
					</v-tab>

					<v-tab
						:to="{
							name: 'employee-penalties-and-rewards',
							query: { employeeId: $route.query.employeeId, name: $route.query.name },
						}">
						<v-icon class="me-1"> mdi-scale-balance </v-icon>
						{{ $T('tabs.penaltiesAndRewards') }}
					</v-tab>
					
					<v-tab
						:to="{
							name: 'job-records',
							query: { employeeId: $route.query.employeeId, name: $route.query.name },
						}"
						href="#records">
						<v-icon class="me-1"> mdi-briefcase-outline </v-icon>
						{{ $T('tabs.records') }}
					</v-tab>

					<v-tab
						:to="{
							name: 'covenant',
							query: { employeeId: $route.query.employeeId, name: $route.query.name },
						}"
						href="#Covenant">
						<!-- <v-icon class="me-1"> mdi </v-icon> -->
						{{ $T('tabs.covenant') }}
					</v-tab>

					<v-tab
						:to="{
							name: 'complaints',
							query: { employeeId: $route.query.employeeId, name: $route.query.name },
						}"
						href="#Complaints">
						<!-- <v-icon class="me-1"> mdi </v-icon> -->
						{{ $T('tabs.complaints') }}
					</v-tab>

					<v-tab
						:to="{
							name: 'employee-training',
							query: { employeeId: $route.query.employeeId, name: $route.query.name },
						}"
						href="#employee-training">
						<!-- <v-icon class="me-1"> mdi </v-icon> -->
						{{ $T('tabs.employee-training') }}
					</v-tab>

					<v-tab
						:to="{
							name: 'salary-employee',
							query: { employeeId: $route.query.employeeId, name: $route.query.name },
						}"
						href="#salary-employee">
						<!-- <v-icon class="me-1"> mdi </v-icon> -->
						{{ $T('tabs.employee-salary') }}
					</v-tab>


					<!-- <v-tab
						:to="{
							name: 'employee-interviews',
							query: { employeeId: $route.query.employeeId, name: $route.query.name },
						}">
						<v-icon class="me-1"> mdi-text-box-check-outline </v-icon>
						{{ $T('tabs.interviews') }}
					</v-tab>
					
					<v-tab href="#complains">
						<v-icon class="me-1"> mdi-chat-alert-outline </v-icon>
						{{ $T('tabs.complains') }}
					</v-tab>
					<v-tab
						:to="{
							name: 'employee-salary',
							query: { employeeId: $route.query.employeeId, name: $route.query.name },
						}">
						<v-icon class="me-1"> mdi-cash </v-icon>
						{{ $T('tabs.salaries') }}
					</v-tab> -->
				</template>
			</v-tabs>
			<v-divider
				vertical
				class="me-1 ms-auto"></v-divider>
			<div
				style="width: 300px"
				class="text-center primary--text px-3">
				{{ $T(`routes.${this.$route.meta.i18nTranslateKey}`) }}
				<template v-if="activeEmployee">
					<br />
					<v-menu
						class="elevation-1"
						offset-y
						open-on-hover>
						<template v-slot:activator="{ on, attrs }">
							<strong
								v-bind="attrs"
								v-on="on">
								{{ activeEmployee.arabicFullName }}
								<v-icon small>mdi-chevron-down</v-icon>
							</strong>
						</template>
						<v-card
							width="200"
							class="pa-4">
							<div class="mb-2">
								<span class="text-caption"> كود الموظف: </span>
								<strong>
									{{ activeEmployee.num }}
								</strong>
							</div>
							<div class="mb-2">
								<span class="text-caption"> رقم جهاز البصمة: </span>
								<strong>
									{{ activeEmployee.code }}
								</strong>
							</div>
							<div class="mb-2">
								<span class="text-caption"> القسم: </span>
								<strong>
									{{ getSectionById(activeEmployee.section)?.name }}
								</strong>
							</div>
							<div class="mb-2">
								<span class="text-caption"> المسمى: </span>
								<strong>
									{{ employeeJobDescription }}
								</strong>
							</div>
						</v-card>
					</v-menu>
				</template>
			</div>
		</div>

		<v-divider></v-divider>

		<router-view
			:employee="employee"
			:employee-id="employeeId"
			:loading-fetch-employee="loadingFetchEmployee"
			@change:employee="(e) => (employee = e)"
			@fetch-employee="fetchEmployeeById"></router-view>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import * as types from '@/store/mutation-types';

export default {
	name: 'Employee',

	data() {
		return {
			tabs: null,

			loadingFetchEmployee: false,

			employee: {},
			employeeId: null,
		};
	},

	computed: {
		employeeJobDescription() {
			if (!this.activeEmployee) return;
			if (!this.positions || !this.positions.length) return;

			const value = this.positions.find((e) => e.id === this.activeEmployee.activeJobDescription);
			return value?.name;
		},
		isEmployee() {
			return !!this.employeeId;
		},
		...mapState({
			activeEmployee: (state) => state.employee.activeEmployee,
			positions: (state) => state.positions.positions,
			sections: state => state.section.sections
		}),
		...mapGetters({
			getSectionById: 'section/getSectionById'
		})
	},

	methods: {
		fetchEmployeeById(id = this.$route.query.employeeId) {
			this.loadingFetchEmployee = true;
			this.$store
				.dispatch('employee/fetchEmployeeById', id)
				.then((res) => {
					this.employeeId = res.employeeId;
					this.employee = res;
				})
				.catch((err) => {
					err.default && err.default();
				})
				.finally(() => {
					this.loadingFetchEmployee = false;
				});
		},
	},

	// todo prevent route when there is no employee
	beforeRouteLeave(from, to, next) {
		this.$store.commit('employee/' + types.DIS_ACTIVATE_EMPLOYEE);
		next();
	},

	created() {
		this.$store.dispatch('section/fetchAllSections')
		if (this.$route.query.employeeId) {
			this.employeeId = this.$route.query.employeeId;
		}
	},

	mounted() {
		if (this.employeeId) {
			this.fetchEmployeeById(this.employeeId);
		}
	},
};
</script>
